import Button from '@carvana/ds-button';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useConfiguration } from '~/context/common/StaticContext';
import { useModalContext } from '~/context/flp/ModalContext/ModalContext';

export default function HeroCta() {
  const { shouldUseTitleCasing } = useConfiguration();
  const { setSoftPullModalOpen } = useModalContext();
  const { trackEvent } = useContext(AnalyticsContext);

  const ctaClick = () => {
    datadogRum.addAction(DATADOG_EVENTS.MARKETING.CLICKS_HERO_CTA);
    trackEvent(ANALYTICS_EVENTS.MARKETING.CLICKS_HERO_CTA);
    setSoftPullModalOpen(true);
  };

  return (
    <Button
      data-analytics-id="Financing Hero Get Your Terms Button"
      size="lg"
      width="100%"
      onClick={ctaClick}
      data-testid="get-your-terms"
    >
      {shouldUseTitleCasing ? 'Get Your Terms' : 'Get your terms'}
    </Button>
  );
}
